module.exports = __webpack_public_path__ + "img/asset4x1.4fc59909.png";